import { jsonToQueryString } from 'utils/functions'
import ApiService from './ApiService'

export async function apiInit(data, query) {
    return ApiService.fetchData({
        url: `?${jsonToQueryString({ action: 'init', ...query, time: new Date().getMilliseconds() })}`,
        method: 'get',
    })
}

export async function apiBuilding(data, query) {
    return ApiService.fetchData({
        url: `?${jsonToQueryString({ ...query })}`,
        method: 'get',
    })
}

export async function apiFloor(data, query) {
    return ApiService.fetchData({
        url: `?${jsonToQueryString({ ...query })}`,
        method: 'get',
    })
}

export async function apiRoom(data, query) {
    return ApiService.fetchData({
        url: `?${jsonToQueryString({ ...query })}`,
        method: 'get',
    })
}

export async function search(data, query) {
    return ApiService.fetchData({
        url: `?${jsonToQueryString({ ...query })}`,
        method: 'get',
    })
}